/* True Machines HOMEPAGE — vanilla JS runtime.
   Ported from the reference DCLogic class (reference-homepage/True Machines Home.dc.html,
   + support.js). Motion values (8000ms advance, 640ms exit overlap, keyframes, easings) are
   preserved verbatim; only the React state machine is re-expressed in vanilla JS.

   Two backend stubs live here (documented in UPDATE-LOG "HOMEPAGE GOTCHAS"):
   1. Get-support lookup: PRODUCTION rule — ANY valid input → "No purchase found" (HOMEPAGE-PORT
      §4.1, amends README G3). The verified "Request received" branch is reachable ONLY via the
      dev hook `window.__tmSupportVerified = true` (set before submit) so its state can be tested.
      Real Shopify customer/order lookup is pending.
   2. Schedule-a-call OTP: any 4+ digit code passes (real SMS provider pending). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Tracking (ANALYTICS.md). tm-analytics.js defines tmTrack and loads first (defer keeps
     document order); the fallback keeps the homepage working if that asset ever fails. */
  function track(name, params) {
    if (typeof window.tmTrack === 'function') window.tmTrack(name, params);
  }

  var HERO_COLORS = ['oklch(0.86 0.09 150)', 'oklch(0.87 0.1 88)', 'oklch(0.87 0.07 255)'];
  var DOT_ACTIVE = 'var(--ink)';
  var DOT_IDLE = 'oklch(0.8 0.01 255)';

  /* ================= HERO STAGE ================= */
  function initHero() {
    var stage = document.querySelector('[data-tm-hero]');
    if (!stage) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var cbBgs = stage.querySelectorAll('[data-tm-cbbg]');
    var cbContents = stage.querySelectorAll('[data-tm-cb]');
    var enterCards = stage.querySelectorAll('[data-tm-art-in]');
    var leaveCards = stage.querySelectorAll('[data-tm-art-out]');
    var dots = stage.querySelectorAll('[data-tm-dot]');
    var counters = stage.querySelectorAll('[data-tm-counter]');

    var slide = 0;
    var leaving = null;
    var timer = null;
    var leaveT = null;

    function show(el, on) {
      var d = on ? '' : 'none'; // '' → the element's stylesheet/inline default (block/flex)
      if (el.style.display !== d) el.style.display = d;
    }
    function forSlide(list, active) {
      for (var i = 0; i < list.length; i++) show(list[i], +list[i].getAttribute('data-slide') === active);
    }

    function render() {
      var i;
      for (i = 0; i < cbBgs.length; i++) cbBgs[i].style.background = HERO_COLORS[slide];
      forSlide(cbContents, slide);
      forSlide(enterCards, slide);
      forSlide(leaveCards, leaving); // leaving===null → none shown
      for (i = 0; i < dots.length; i++) {
        dots[i].style.background = +dots[i].getAttribute('data-slide') === slide ? DOT_ACTIVE : DOT_IDLE;
      }
      for (i = 0; i < counters.length; i++) counters[i].textContent = '0' + (slide + 1) + ' / 03';
    }

    function go(n) {
      if (n === slide) return; // clicking the active dot is a no-op (H3)
      leaving = slide;
      slide = n;
      render();
      clearTimeout(leaveT);
      leaveT = setTimeout(function () { leaving = null; render(); }, 640);
    }

    // Dot clicks — tracked BEFORE the go() no-op guard is applied, but only for a real change:
    // clicking the active dot does nothing visible (H3), so it must not count as engagement.
    for (var d = 0; d < dots.length; d++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var target = +btn.getAttribute('data-slide');
          if (target !== slide) track('tm_stage_dot_click', { slide: target });
          go(target);
        });
      })(dots[d]);
    }

    render();
    if (!reduce) timer = setInterval(function () { go((slide + 1) % 3); }, 8000); // H1 / H4
    window.addEventListener('pagehide', function () { clearInterval(timer); clearTimeout(leaveT); });
  }

  /* ================= BURGER MENU ================= */
  function initBurger() {
    var burger = document.querySelector('[data-tm-burger]');
    var header = document.querySelector('.tm-home-header');
    if (!burger || !header) return;

    function setOpen(open) {
      header.classList.toggle('is-menu-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    burger.addEventListener('click', function () {
      setOpen(!header.classList.contains('is-menu-open'));
    });
    // Each menu link closes the menu (then the href navigates / scrolls).
    header.querySelectorAll('[data-tm-menu] a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
  }

  /* ================= MODALS (call + support) ================= */

  /* ---- Dynamic call-slot generation (SPEC CALL-SLOTS §3–§4) ----
     Slots are generated from the current time in IST — the call centre runs on IST business hours,
     not the visitor's device clock. The button shows a friendly relative label; the STORED value is
     always an absolute datetime string so the leads dashboard never goes stale. Tweakable rules: */
  var SLOT_TIMES = [{ h: 11, m: 0 }, { h: 14, m: 0 }, { h: 17, m: 30 }]; // 11:00 AM, 2:00 PM, 5:30 PM IST
  var OPEN_DAYS  = [1, 2, 3, 4, 5, 6];  // 0=Sun … 6=Sat → Mon–Sat open, SUNDAY CLOSED
  var LEAD_MIN   = 60;                   // hide any slot < 60 min from now
  var SLOT_COUNT = 6;                    // keep the existing 2×3 grid

  /* All times IST (Asia/Kolkata). IST has no DST → fixed +5:30 offset. */
  var IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
  var timeStr = function (h, m) { var ap = h < 12 ? 'AM' : 'PM', hh = h % 12 || 12; return hh + ':' + pad(m) + ' ' + ap; };

  // Epoch (ms) of an IST civil datetime — TZ-independent (correct whatever the device TZ is).
  function istEpoch(y, mo, d, h, m) { return Date.UTC(y, mo, d, h, m) - IST_OFFSET_MS; }

  function generateCallSlots(nowMs) {
    var minMs   = nowMs + LEAD_MIN * 60000;
    var istNow  = new Date(nowMs + IST_OFFSET_MS);      // shift so getUTC* reads the IST wall clock
    var y = istNow.getUTCFullYear(), mo = istNow.getUTCMonth(), d0 = istNow.getUTCDate();
    var todayNum = Date.UTC(y, mo, d0);                 // midnight-today key for the day diff
    var out = [];

    for (var off = 0; off < 14 && out.length < SLOT_COUNT; off++) {
      var day = new Date(Date.UTC(y, mo, d0 + off));    // Date.UTC normalises month/year rollover
      if (OPEN_DAYS.indexOf(day.getUTCDay()) === -1) continue;      // closed day → skip
      for (var i = 0; i < SLOT_TIMES.length && out.length < SLOT_COUNT; i++) {
        var t  = SLOT_TIMES[i];
        var ms = istEpoch(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), t.h, t.m);
        if (ms < minMs) continue;                        // already past / inside the lead buffer

        var diff = Math.round((Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate()) - todayNum) / 86400000);
        var dayLabel = diff === 0 ? 'Today' : diff === 1 ? 'Tomorrow'
                     : WD[day.getUTCDay()] + ' ' + day.getUTCDate() + ' ' + MO[day.getUTCMonth()];
        var value    = WD[day.getUTCDay()] + ' ' + day.getUTCDate() + ' ' + MO[day.getUTCMonth()] + ', ' + timeStr(t.h, t.m);

        out.push({ dayLabel: dayLabel, timeLabel: timeStr(t.h, t.m), value: value, ms: ms });
      }
    }
    return out;
  }

  function initModals() {
    var root = document.querySelector('[data-tm-modals]');
    if (!root) return;

    var scrim = root.querySelector('[data-tm-scrim]');
    var panel = root.querySelector('[data-tm-panel]');
    var kicker = root.querySelector('[data-tm-kicker]');
    var callView = root.querySelector('[data-tm-view="call"]');
    var supportView = root.querySelector('[data-tm-view="support"]');

    var state = { modal: null, callStep: 1, callSlot: '', callSlotLabel: '', callPhone: '', callOtp: '', supportVal: '' };

    // ---- element handles ----
    var q = function (s) { return root.querySelector(s); };
    var callSteps = { 1: q('[data-tm-callstep="1"]'), 2: q('[data-tm-callstep="2"]'), 3: q('[data-tm-callstep="3"]') };
    var supportStates = { form: q('[data-tm-support="form"]'), done: q('[data-tm-support="done"]'), notfound: q('[data-tm-support="notfound"]') };
    var slotsContainer = q('[data-tm-slots]');   // JS fills this per openCall() — buttons are dynamic
    var callSubmitBtn = q('[data-tm-callsubmit]');
    var callPhoneIn = q('[data-tm-callphone]');
    var callPhoneEcho = q('[data-tm-callphone-echo]');
    var callOtpIn = q('[data-tm-callotp]');
    var supportIn = q('[data-tm-supportval]');
    var callErr = root.querySelectorAll('[data-tm-callerr]');
    var supportErr = q('[data-tm-supporterr]');
    var bookedLine = q('[data-tm-bookedline]');
    var callResendBtn = q('[data-tm-callresend]');
    var callTimerEl = q('[data-tm-calltimer]');
    var callResendTimer = null;
    var notFoundVal = root.querySelectorAll('[data-tm-notfoundval]');

    function show(el, on) { if (el) el.style.display = on ? '' : 'none'; }

    function setErr(nodeList, msg) {
      nodeList.forEach ? nodeList.forEach(setOne) : setOne(nodeList);
      function setOne(box) { if (!box) return; box.textContent = msg || ''; box.style.display = msg ? '' : 'none'; }
    }

    var modalLocked = false;
    function renderModal() {
      /* Freeze the page behind the modal on open, restore on close. Guarded so the many
         renderModal() calls during a flow (step changes) don't stack locks. Same reason as the
         PDP lead modal: without this a touch-drag inside the popup scrolls the homepage behind it
         on the Android Instagram in-app browser (and iOS WebKit). */
      if (!!state.modal !== modalLocked) {
        modalLocked = !!state.modal;
        if (modalLocked) { if (window.TM && window.TM.lockScroll) window.TM.lockScroll(); }
        else if (window.TM && window.TM.unlockScroll) { window.TM.unlockScroll(); }
      }
      show(scrim, !!state.modal);
      if (!state.modal) return;
      kicker.textContent = state.modal === 'call' ? 'Schedule a call' : 'Get support';
      show(callView, state.modal === 'call');
      show(supportView, state.modal === 'support');
      if (state.modal === 'call') {
        show(callSteps[1], state.callStep === 1);
        show(callSteps[2], state.callStep === 2);
        show(callSteps[3], state.callStep === 3);
      }
    }

    // ---- open / close ----
    function openCall(e) {
      if (e) e.preventDefault();
      stopCallResendTimer();
      state.modal = 'call'; state.callStep = 1; state.callSlot = ''; state.callSlotLabel = ''; state.callPhone = ''; state.callOtp = '';
      renderCallSlots();   // regenerate from the current clock — a long-idle tab stays fresh
      if (callPhoneIn) callPhoneIn.value = ''; if (callOtpIn) callOtpIn.value = '';
      setErr(callErr, '');
      renderModal();
    }
    function openSupport(e) {
      if (e) e.preventDefault();
      state.modal = 'support'; state.supportVal = '';
      if (supportIn) supportIn.value = '';
      setErr(supportErr, '');
      show(supportStates.form, true); show(supportStates.done, false); show(supportStates.notfound, false);
      renderModal();
    }
    function closeModal() { stopCallResendTimer(); state.modal = null; setErr(callErr, ''); setErr(supportErr, ''); renderModal(); }

    // Triggers live in the help section (outside the modal root) — wire via document.
    document.querySelectorAll('[data-tm-open="call"]').forEach(function (b) { b.addEventListener('click', openCall); });
    document.querySelectorAll('[data-tm-open="support"]').forEach(function (b) { b.addEventListener('click', openSupport); });

    if (scrim) scrim.addEventListener('click', closeModal);              // backdrop closes (C8)
    if (panel) panel.addEventListener('click', function (e) { e.stopPropagation(); }); // panel click does not
    root.querySelectorAll('[data-tm-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.modal) closeModal(); });

    // ---- call flow ----
    function paintSlot(btn, on) {
      btn.style.borderColor = on ? 'var(--accent)' : 'var(--line)';
      btn.style.background = on ? 'oklch(0.95 0.035 255)' : 'transparent';
    }

    // Build the slot buttons from generateCallSlots() into [data-tm-slots]. Called on every openCall()
    // so the list always reflects the current IST clock. Each button replicates the original hardcoded
    // markup/inline styles (so it looks identical), carries data-tm-slot (ABSOLUTE stored value) and
    // data-tm-slot-label (friendly text for the confirmation echo).
    function renderCallSlots() {
      if (!slotsContainer) return;
      var slots = generateCallSlots(Date.now());
      slotsContainer.innerHTML = '';
      if (!slots.length) {
        // Guard: should never happen with the confirmed rules — degrade gracefully, block Continue.
        var note = document.createElement('div');
        note.style.cssText = 'grid-column:1 / -1;font-size:0.82rem;line-height:1.5;color:var(--muted);padding:6px 0';
        note.textContent = 'No slots available right now — please try again later.';
        slotsContainer.appendChild(note);
        if (callSubmitBtn) callSubmitBtn.disabled = true;
        return;
      }
      if (callSubmitBtn) callSubmitBtn.disabled = false;
      for (var i = 0; i < slots.length; i++) {
        var s = slots[i];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-tm-slot', s.value);                       // ABSOLUTE stored string
        btn.setAttribute('data-tm-slot-label', s.dayLabel + ' at ' + s.timeLabel); // friendly echo
        btn.style.cssText = 'cursor:pointer;text-align:left;padding:11px 14px;display:flex;flex-direction:column;gap:3px;font-family:inherit;border:1px solid var(--line);background:transparent';
        var day = document.createElement('span');
        day.style.cssText = 'font-size:0.6rem;text-transform:uppercase;letter-spacing:0.06em;color:var(--muted)';
        day.textContent = s.dayLabel;
        var time = document.createElement('span');
        time.style.cssText = 'font-size:0.92rem;font-weight:600;font-variant-numeric:tabular-nums';
        time.textContent = s.timeLabel;
        btn.appendChild(day); btn.appendChild(time);
        slotsContainer.appendChild(btn);
      }
    }

    // Slot selection via event delegation — buttons are created dynamically each openCall(), so we
    // must NOT bind to a NodeList captured at init.
    if (slotsContainer) slotsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-tm-slot]') : null;
      if (!btn || !slotsContainer.contains(btn)) return;
      state.callSlot = btn.getAttribute('data-tm-slot');            // absolute value → stored / analytics
      state.callSlotLabel = btn.getAttribute('data-tm-slot-label'); // friendly label → confirmation echo
      var all = slotsContainer.querySelectorAll('[data-tm-slot]');
      for (var i = 0; i < all.length; i++) paintSlot(all[i], all[i] === btn);
      setErr(callErr, '');
    });
    if (callPhoneIn) callPhoneIn.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 10); state.callPhone = this.value; setErr(callErr, '');
    });
    if (callOtpIn) callOtpIn.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 6); state.callOtp = this.value; setErr(callErr, '');
    });
    q('[data-tm-callsubmit]').addEventListener('click', function () {
      if (!state.callSlot) return setErr(callErr, 'Pick a slot for your call.');
      if (state.callPhone.length !== 10) return setErr(callErr, 'Enter a 10-digit mobile number.');
      var btn = this;
      if (btn.disabled) return;                     // guard double-submit while the send is in flight
      btn.disabled = true; btn.classList.add('is-loading'); setErr(callErr, '');
      var send = (window.TM && window.TM.otpSend) ? window.TM.otpSend(state.callPhone) : Promise.resolve({ ok: true });
      send.then(function (res) {
        btn.disabled = false; btn.classList.remove('is-loading');
        if (!res || !res.ok) return setErr(callErr, res && res.rateLimited
          ? 'Too many attempts. Please wait a minute and try again.'
          : "Couldn't send the code — check the number and try again.");
        if (callPhoneEcho) callPhoneEcho.textContent = '+91 ' + state.callPhone;
        state.callStep = 2; state.callOtp = ''; if (callOtpIn) callOtpIn.value = ''; renderModal();
        startCallResendTimer();
      });
    });
    q('[data-tm-callverify]').addEventListener('click', function () {
      if (state.callOtp.length < 4) return setErr(callErr, 'Enter the code we sent you.');
      var btn = this;
      if (btn.disabled) return;
      btn.disabled = true; btn.classList.add('is-loading'); setErr(callErr, '');
      var verify = (window.TM && window.TM.otpVerify) ? window.TM.otpVerify(state.callPhone, state.callOtp) : Promise.resolve(true);
      verify.then(function (verified) {
        btn.disabled = false; btn.classList.remove('is-loading');
        if (!verified) return setErr(callErr, "That code isn't right. Check it and try again.");
        // tm_call_booked — fires on reaching the Booked step (step 3), the completed flow, now a
        // VERIFIED number. Maps to Meta `Lead`, same as tm_lead_submit: same funnel value, different source.
        // placement:'call' keeps tm-analytics.js content_name/method a clean low-cardinality label
        // (the slot is now an arbitrary datetime string — see SPEC CALL-SLOTS §5c). The readable
        // absolute slot still rides on the custom event + goes to /lead. Event NAME unchanged → Meta Lead.
        track('tm_call_booked', { placement: 'call', slot: state.callSlot });

        /* Structured lead capture → D1 (tm-leads dashboard), mirroring the PDP hook in tm-pdp.js so
           the calling team sees call bookings in the same queue. UNLIKE the PDP flow there is no CAPI
           leg and no Meta event_id here, so we mint a synthetic id purely as the DB dedupe key. The
           call flow has no pincode (source='call' rows get no geo/map dot); we store the ABSOLUTE slot
           string ('Thu 30 Jul, 11:00 AM') so the dashboard is unambiguous forever — not a relative label.
           Fire-and-forget: a persist failure must NEVER block the booking. /lead is origin-gated to truemachines.co. */
        if (window.TM && window.TM.newEventId) {
          var attr = window.TM.readUtm ? window.TM.readUtm() : {}; // creative attribution for call bookings too
          try {
            fetch('https://capi.truemachines.co/lead', {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              keepalive: true,
              body: JSON.stringify(Object.assign({
                phone: state.callPhone,                       // raw 10-digit number the user typed
                pincode: '',                                  // no pincode in the call flow
                slot: state.callSlot,                         // requested call slot — ABSOLUTE datetime string
                event_id: window.TM.newEventId(),             // synthetic — call flow has no Meta event_id
                source: 'call',
                ts: new Date().toISOString()
              }, attr))                                       // utm_source/medium/campaign/content/term + landing_path
            });
          } catch (e) { /* never block the booking */ }
        }

        bookedLine.innerHTML = 'Our expert will call you <strong style="color:var(--ink)">' +
          state.callSlotLabel + '</strong> on <strong style="color:var(--ink);font-variant-numeric:tabular-nums">+91 ' +
          state.callPhone + '</strong>.';
        state.callStep = 3; renderModal();
      });
    });
    function startCallResendTimer() {
      var left = 15;
      if (callResendBtn) callResendBtn.hidden = true;
      if (callTimerEl) { callTimerEl.hidden = false; callTimerEl.textContent = 'Resend code in ' + left + 's'; }
      if (callResendTimer) clearInterval(callResendTimer);
      callResendTimer = setInterval(function () {
        left -= 1;
        if (left <= 0) {
          clearInterval(callResendTimer); callResendTimer = null;
          if (callTimerEl) callTimerEl.hidden = true;
          if (callResendBtn) callResendBtn.hidden = false;
        } else if (callTimerEl) {
          callTimerEl.textContent = 'Resend code in ' + left + 's';
        }
      }, 1000);
    }
    function stopCallResendTimer() { if (callResendTimer) { clearInterval(callResendTimer); callResendTimer = null; } }

    if (callResendBtn) callResendBtn.addEventListener('click', function () {
      if (callResendBtn.hidden) return;
      callResendBtn.hidden = true; setErr(callErr, '');
      var send = (window.TM && window.TM.otpSend) ? window.TM.otpSend(state.callPhone) : Promise.resolve({ ok: true });
      send.then(function (res) {
        if (!res || !res.ok) {
          setErr(callErr, res && res.rateLimited ? 'Too many attempts. Please wait a minute.' : "Couldn't resend the code — try again.");
          callResendBtn.hidden = false; return;
        }
        startCallResendTimer();
      });
    });

    q('[data-tm-callback]').addEventListener('click', function () { stopCallResendTimer(); state.callStep = 1; setErr(callErr, ''); renderModal(); });

    // ---- support flow ----
    if (supportIn) supportIn.addEventListener('input', function () { state.supportVal = this.value; setErr(supportErr, ''); });
    q('[data-tm-supportsubmit]').addEventListener('click', function () {
      var v = state.supportVal.trim();
      if (v.length < 5) return setErr(supportErr, 'Enter your mobile number or order ID.');
      // PRODUCTION stub (HOMEPAGE-PORT §4.1): no owner lookup yet → everyone is "not found",
      // EXCEPT the dev hook that lets the verified state be tested.
      var verified = window.__tmSupportVerified === true;
      setErr(supportErr, '');
      // tm_support_request — support intent, deliberately NOT a Lead: feeding it to ad
      // optimization would teach Meta to buy existing owners, not buyers (ANALYTICS.md).
      track('tm_support_request', { outcome: verified ? 'received' : 'no_purchase' });
      if (verified) {
        show(supportStates.form, false); show(supportStates.done, true); show(supportStates.notfound, false);
      } else {
        notFoundVal.forEach(function (n) { n.textContent = v; });
        show(supportStates.form, false); show(supportStates.done, false); show(supportStates.notfound, true);
      }
    });
    q('[data-tm-supportretry]').addEventListener('click', function () {
      show(supportStates.form, true); show(supportStates.done, false); show(supportStates.notfound, false); setErr(supportErr, '');
    });
    q('[data-tm-supportexplore]').addEventListener('click', function () {
      closeModal();
      var el = document.getElementById('machines');
      if (el) { var top = el.getBoundingClientRect().top + window.scrollY - 72; window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); }
    });

    renderModal();
  }

  ready(function () { initHero(); initBurger(); initModals(); });
})();
